/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

// Mock for react-native in web builds
// Only include what's actually needed, most web code shouldn't import from react-native
// When importing from react-native in common package, ensure to import from 'react-native' and not from native-mocks/react-native

export const Platforn = {
  OS: 'web',
  select: (obj: any) => obj.web || obj.default
};

export const StyleSheet = {
  create: (styles: any) => styles
};

export const Dimensions = {
  get: () => ({ width: window.innerWidth, height: window.innerHeight })
};

type ColorSchemeName = 'light' | 'dark' | null | undefined;

type AppearancePreferences = {
  colorScheme: ColorSchemeName;
};

type AppearanceListener = (preferences: AppearancePreferences) => void;

export const Appearance = {
  getColorScheme: (): ColorSchemeName => undefined,

  addChangeListener: (_listener: AppearanceListener) => {
    return {
      remove: () => {}
    };
  }
};
